/**
 * Resolve `promise`, or `fallback` once `ms` elapse — whichever comes first. The timer is
 * cleared when the promise settles first, so a fast path leaves nothing ticking behind;
 * the losing promise itself is not cancelled (callers pass an AbortSignal if they need that).
 */
export function withDeadline<T, F>(promise: Promise<T>, ms: number, fallback: F): Promise<T | F> {
	return new Promise<T | F>((resolve, reject) => {
		const timer = setTimeout(() => resolve(fallback), ms)
		promise.then(
			(value) => {
				clearTimeout(timer)
				resolve(value)
			},
			(error: unknown) => {
				clearTimeout(timer)
				reject(error)
			},
		)
	})
}
